<Button 
  on:click
  border="none" 
  bg={bg} 
  px={props.px} 
  py={props.py}
  rounded={rounded}
  pointer
  hover
  > 
  <Icon 
    name="delete"
    size={props.size}
    color={color}
    />
</Button>

<script>
  import { Button, Icon }from 'svelte-stylo';

  export let
    size = 'nm',
    bg = 'surface',
    color = 'primary',
    rounded = '0';

  const variants = {
    'sm': { px: 'xs', py: 'xs', size: '1rem' },
    'nm': { px: 'xs', py: 'xs', size: '1.25rem' },
    'md': { px: 'sm', py: 'sm', size: '1.75rem' },
    'lg': { px: 'sm', py: 'sm', size: '2.25rem' },
  } 

  let props = variants[size];
</script>